import { FormItem } from "../../infinity-item/interfaces/FormItem.interface";
import { addRule } from "../methods/addRule";

/**
 * [Impure]
 * @param ruleObj
 * @param item
 */
export function ruleReducer(ruleObj: any, item: FormItem): any {
    // If no rules return rule object.
    if (!item.rules) return ruleObj;

    // Copy setTarget values from item.rules to rule object.
    Object.keys(item.rules).forEach(watchTarget => {
        const ruleset = item.rules[watchTarget];
        Object.keys(ruleset).forEach(setTarget => {
            addRule(ruleObj, watchTarget, setTarget, ruleset[setTarget]);
        });
    });

    // Recurse on children.
    if (item.items && item.items.length) return item.items.reduce(ruleReducer, ruleObj);

    // Return rule object.
    return ruleObj;
}
